import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class InternationalDomesticFilter extends Component {
    state = {
        internationalLists:[{value: '', label: 'All'},{value:'yes', label: 'Yes'},{value:'no', label: 'No'}],
        internationalValue:{value: '', label: 'All'},

    };
    componentDidMount(){

    }

    resetInternationalFilter(){
        this.setState({
        internationalValue: {value: '', label: 'All'},
        })
    }

    changeValue(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.props.onSelectInternationalFilter(optionSelected);
        this.setState({
            internationalValue:optionSelected,
        });
    }
    render() {

        return (
            <Select name="product_type"
                value={this.state.internationalValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeValue.bind(this)}
                options={this.state.internationalLists}
                placeholder="Is International"
        />
        );

    }
}
export default InternationalDomesticFilter;